<div class="gemini-wrapper" [class.open]="open">
  <button mat-fab
          class="gemini-launch"
          matTooltip="{{ 'gemini.launch.tooltip' | translate }}"
          type="button"
          (click)="toggle()">
    <mat-icon class="main-icon">auto_awesome</mat-icon>
  </button>

  <div class="gemini-panel" *ngIf="open">
    <div class="header">
      <span class="title">{{ 'signature.header.title' | translate }}</span>
      <button mat-icon-button
              [attr.aria-label]="'signature.header.closeAriaLabel' | translate"
              (click)="toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="chat-window">
      <app-loading *ngIf="loadingHistory" [hideText]="true"></app-loading>
      <div *ngIf="!loadingHistory && !messages.length && !sending"
           class="bubble welcome ai"
           [innerHTML]="'signature.chat.welcome' | translate">
      </div>
      <ng-container *ngIf="!loadingHistory">
        <div *ngFor="let m of messages"
             [class.user]="m.from === 'user'"
             [class.ai]="m.from === 'ai'">
          <div class="bubble">{{ m.text }}</div>
        </div>
      </ng-container>
      <div class="loading" *ngIf="sending" aria-label="Loading">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>

    <form class="input-row" (ngSubmit)="send()">
      <mat-form-field appearance="outline" class="flex-1">
        <input matInput
               placeholder="{{ 'signature.input.placeholder' | translate }}"
               [formControl]="input" />
      </mat-form-field>
      <button mat-icon-button
              color="primary"
              type="submit"
              [disabled]="input.invalid || sending"
              [attr.aria-label]="'signature.input.sendAriaLabel' | translate">
        <mat-icon>send</mat-icon>
      </button>
    </form>
  </div>
</div>
